/* global Intercom */
import React from 'react';

const prepareError = (error) => {
    if (!error) {
        return null;
    }

    if (error && error.toLowerCase().indexOf('we are unable to redirect your account') !== -1) {
        return (
            <span>
                {error}
                {typeof Intercom !== 'undefined' ? <span>
                    {' Please '}
                    <a
                        href={'#intercom-container'}
                        onClick={(e) => {
                            e.preventDefault();
                            Intercom('show');
                        }}
                    >
                        contact our support team
                    </a>
                    {' for more assistance.'}
                </span> : ''}
            </span>
        );
    }
    return error;
};

export default prepareError;



// WEBPACK FOOTER //
// ./src/client/utils/issue-with-redirect-error.js